// extracted by mini-css-extract-plugin
export default {"wrapper":"logout-page_wrapper__JtZPB","body":"logout-page_body__RbOoF"};